module.exports = __webpack_public_path__ + "img/购物.50e1aaee.jpg";